const LeafSprig = ({ className = "" }) => (
  <svg viewBox="0 0 60 90" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={className}>
    <path d="M30 88C30 88 28 60 30 40C32 20 30 2 30 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M30 20C30 20 18 16 14 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M30 34C30 34 42 30 46 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M30 48C30 48 16 45 10 36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M30 62C30 62 44 58 50 48" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default LeafSprig;
